import React from 'react';
import styled from "styled-components";
import Breadcrumbs from "../../components/Breadcrumbs";
import delivery_1 from "../../images/delivery_1.png";
import delivery_2 from "../../images/delivery_2.png";
import delivery_3 from "../../images/delivery_3.png";
import delivery_4 from "../../images/delivery_4.png";
import delivery_5 from "../../images/delivery_5.png";
import delivery_6 from "../../images/delivery_6.png";
import delivery_7 from "../../images/delivery_7.png";

const ContentBlock = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 36px;


    > img {
        width: 158px;
        height: 76px;
        margin-bottom: 12px;
    }

    h2 {
        color: #8a8a8a;
        font-size: 24px;
        font-weight: 500;
        padding-bottom: 5px;
        margin-bottom: 20px;
        border-bottom: 1px solid #dcdcdc;
        max-width: 332px;
        width: 100%;
    }

    &.courier_block {
        @media screen and (max-width: 826px) {
            h2 {
                border-bottom: none;
            }
        }
    }

    h3 {
        font-size: 24px;
        margin-bottom: 5px;
    }

    p {
        margin-bottom: 0;

        &:not(:last-child) {
            margin-bottom: 25px;
        }
    }
`;

const DeliveryItems = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 34px 65px;
    margin-bottom: 25px;
    margin-top: 38px;

    @media screen and (max-width: 826px) {
        gap: 26px 45px;

    }
    
`;

const Item = styled.div`
    display: flex;
    gap: 32px;
    align-items: center;
    @media screen and (max-width: 826px) {
        gap: 14px;
    }

    img {
        width: 81px;
        height: 81px;

        @media screen and (max-width: 826px) {
            width: 73px;
            height: 73px;
        }
    }

    > span {
        display: flex;
        flex-direction: column;
        gap: 8px;

        .actions {
            display: flex;
            flex-direction: column;
            gap: 4px;

            a {
                text-decoration: none;
                font-size: 16px;
                color: #5B77CB;
            }
        }

        > span {
            color: #000000;
            font-size: 18px;
        }
    }
`;

const StyledDeliveryPage = styled.div`
    display: flex;
    flex-direction: column;
    padding: 45px 18.75% 150px 18.75%;
    font-weight: 500;

    .bigMargin {
        margin-bottom: 75px;
    }

    p {
        font-size: 18px;
        margin-bottom: 0;
    }

    h1 {
        margin-top: 15px;
        font-weight: 500;
        font-size: 26px;
        line-height: 34px;

        color: #000000;
        margin-bottom: 20px;
    }

    @media screen and (max-width: 1919px) {
        padding: 45px 20px 150px 20px;
    }
`;

function DeliveryPage() {
    return (
        <StyledDeliveryPage>
            <Breadcrumbs/>
            <h1>Доставка заказов</h1>
            <p>
                Отправка грузов по России и в страны ближнего зарубежья производится крупнейшими и зарекомендовавшими
                себя транспортными компаниями со склада в г. Челябинске.
                <br/>
                По Вашей просьбе стоимость доставки можно
                включить в стоимость инструмента.
            </p>

            <DeliveryItems>
                <Item>
                    <img src={delivery_1} alt=""/>
                    <span>
                        <span>ООО "Деловые линии"</span>
                        <div className="actions">
                            <a href={"https://www.dellin.ru/requests/?step=freight&requestType=cargo-single"}>Рассчитать стоимость доставки</a>
                            <a href={"https://www.dellin.ru/"}>Статус доставки грузки</a>
                        </div>
                    </span>
                </Item>
                <Item>
                    <img src={delivery_2} alt=""/>
                    <span>
                        <span>ООО «ЖелДорЭкспедиция»</span>
                        <div className="actions">
                            <a href={"https://www.jde.ru/online/calculator.html"}>Рассчитать стоимость доставки</a>
                            <a href={"https://www.jde.ru/online/tracking.html"}>Статус доставки грузки</a>
                        </div>
                    </span>
                </Item>
                <Item>
                    <img src={delivery_3} alt=""/>
                    <span>
                        <span>ООО "СДЕК"</span>
                        <div className="actions">
                            <a href={"https://www.cdek.ru/ru/faq/rates-and-products/kak-rasschitat-stoimost-dostavki/"}>Рассчитать стоимость доставки</a>
                            <a href={"https://www.cdek.ru/ru/tracking/"}>Статус доставки грузки</a>
                        </div>
                    </span>
                </Item>
                <Item>
                    <img src={delivery_4} alt=""/>
                    <span>
                        <span>ООО "ТК КИТ"</span>
                        <div className="actions">
                            <a href={"https://tk-kit.ru/order"}>Рассчитать стоимость доставки</a>
                            <a href={"https://tk-kit.ru/services"}>Статус доставки грузки</a>
                        </div>
                    </span>
                </Item>
                <Item>
                    <img src={delivery_5} alt=""/>
                    <span>
                        <span>ООО "Энергия"</span>
                        <div className="actions">
                            <a href={"https://nrg-tk.ru/client/calculator/"}>Рассчитать стоимость доставки</a>
                            <a href={"https://nrg-tk.ru/client/tracking/"}>Статус доставки грузки</a>
                        </div>
                    </span>
                </Item>
                <Item>
                    <img src={delivery_6} alt=""/>
                    <span>
                        <span>ООО ТК "Экспресс-Авто"</span>
                        <div className="actions">
                            <a href={"https://expressauto.ru/autokalkulyator"}>Рассчитать стоимость доставки</a>
                            <a href={"https://expressauto.ru/bill"}>Статус доставки грузки</a>
                        </div>
                    </span>
                </Item>
            </DeliveryItems>
            <p className={"bigMargin"}>
                Также возможна отправка грузов другими транспортными компаниями, по пожеланию заказчика и самовывозом со
                склада в Челябинске.
            </p>
            <ContentBlock className={"courier_block"}>
                <h2>Курьером</h2>

                <h3>Как доставят</h3>
                <p>Доставка осуществляется курьером по указанному в заказе адресу. Представитель курьерской службы
                    свяжется с Вами по контактному телефону для согласования даты и времени доставки. Доставка до
                    терминала вашего города, доставка до адреса.</p>

                <h3>Информация о заказе</h3>
                <p>
                    Поставщик отправляет скан-копию транспортной накладной покупателю,транспортная компания извещает о
                    прибытие груза: звонок, смс сообщение или сообщением на эл почту, также свой заказ можно отслеживать
                    в личном кабинете транспортной компании.
                </p>
            </ContentBlock>
            <ContentBlock>
                <h2>Почтой</h2>
                <img src={delivery_7} alt=""/>

                <h3>Как доставят</h3>
                <p>До отделения почты РФ, по индексу, ближайшему к адресу доставки </p>

                <h3>Информация о заказе</h3>
                <p>Вам придет уведомление по SMS и на e-mail об отправке посылки, а также sms и e-mail о прогнозируемой
                    доставке и извещение в ваш почтовый ящик</p>
            </ContentBlock>
        </StyledDeliveryPage>
    );
}

export default DeliveryPage;